import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=b28ff57e"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b28ff57e')) {
      api.createRecord('b28ff57e', component.options)
    } else {
      api.reload('b28ff57e', component.options)
    }
    module.hot.accept("./GlobalSearch.vue?vue&type=template&id=b28ff57e", function () {
      api.rerender('b28ff57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/GlobalSearch.vue"
export default component.exports